export type TooltipSelectOption = {
	readonly value: string
	readonly label: string
	selected: boolean
	hasSentiment: boolean
	sentiment: Sentiment
}

export type Sentiment = 1 | 0 | -1 | null

// eslint-disable-next-line no-shadow
export const SENTIMENT_BACKGROUND_COLOR = {
	GREEN: '#19DA8F',
	YELLOW: '#FBC02D',
	RED: '#FF4955',
	GRAY: '#A7A7A7',
} as const

type ObjectValues<T> = T[keyof T]

type SentimentBackgroundColor = ObjectValues<typeof SENTIMENT_BACKGROUND_COLOR>

export type ColorOption = {
	color: SentimentBackgroundColor
	sentiment: Sentiment
}

export const colorOptions: ColorOption[] = [
	{ color: SENTIMENT_BACKGROUND_COLOR.YELLOW, sentiment: null },
	{ color: SENTIMENT_BACKGROUND_COLOR.GREEN, sentiment: 1 },
	{ color: SENTIMENT_BACKGROUND_COLOR.GRAY, sentiment: 0 },
	{ color: SENTIMENT_BACKGROUND_COLOR.RED, sentiment: -1 },
]

export type HandleSetSentiment = (newSentiment: Sentiment, value: string) => void
